import React from "react";
import {
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Button,
} from "@material-ui/core";
import intl from "react-intl-universal";

interface DeleteAccountConfirmDialogProps {
	open: boolean;
	loading?: boolean;
	onClose: () => void;
	onConfirm: () => void;
}

export function DeleteAccountConfirmDialog({
	open,
	loading = false,
	onClose,
	onConfirm,
}: DeleteAccountConfirmDialogProps) {
	return (
		<Dialog
			open={open}
			onClose={loading ? undefined : onClose}
			maxWidth="xs"
			fullWidth
		>
			<DialogTitle>{intl.get("profile.delete_confirm_title")}</DialogTitle>
			<DialogContent>
				<DialogContentText>
					{intl.get("profile.delete_confirm_msg")}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button
					onClick={onClose}
					variant="outlined"
					color="secondary"
					disabled={loading}
				>
					{intl.get("profile.delete_cancel")}
				</Button>
				<Button
					onClick={onConfirm}
					variant="contained"
					disabled={loading}
					style={{ backgroundColor: "#d32f2f", color: "#fff" }}
				>
					{intl.get("profile.delete_confirm")}
				</Button>
			</DialogActions>
		</Dialog>
	);
}

interface AccountDeletedDialogProps {
	open: boolean;
	onConfirm: () => void;
}

export function AccountDeletedDialog({
	open,
	onConfirm,
}: AccountDeletedDialogProps) {
	return (
		<Dialog open={open} maxWidth="xs" fullWidth>
			<DialogTitle>{intl.get("profile.delete_done_title")}</DialogTitle>
			<DialogContent>
				<DialogContentText>
					{intl.get("profile.delete_loggedout_msg")}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={onConfirm} variant="contained" color="primary">
					{intl.get("profile.delete_done_ok")}
				</Button>
			</DialogActions>
		</Dialog>
	);
}
